import Vue from 'vue'
import Vuex from 'vuex'
import vuexAlong from 'vuex-along' //vuex-along
//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
    state:{
      //存放的键值对就是所要管理的状态
      login:false,
    },
    mutations:{
      getUserName(state,data){
        state.login = data
      }
    },
    plugins: [vuexAlong]
})
 export default store



// WEBPACK FOOTER //
// ./src/store/index.js